export default "__VITE_ASSET__Bc50APxa__"